import { userProfiles } from '../constants/profilesUsers';
export default [
  /* Dashboard */
  {
    _name: 'CSidebarNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    fontIcon: 'fas fa-tachometer-alt',
  },
  {
    _name: 'CSidebarNavItem',
    name: 'FAQ de MailUpdate',
    href: process.env.VUE_APP_URL_FAQ,
    fontIcon: 'fas fa-book',
    _class: 'bg-info text-white',
    target: '_blank'
  },
  /* Administracion del sistema-Title (solo para admin[7], coord[5] y superv[6] ) */
  {
    _name: 'CSidebarNavTitle',
    _children: ['Administración del sistema'],
    roles: [userProfiles.adminUser, userProfiles.coordinator, userProfiles.superviser]
  },
  /* Menu usuarios (solo para admin[7], coord[5] y superv[6] ) */
  {
    _name: 'CSidebarNavDropdown',
    name: 'Usuarios',
    to: '/',
    fontIcon: 'fas fa-users',
    roles: [userProfiles.adminUser, userProfiles.coordinator, userProfiles.superviser],
    items: [{
        name: 'Crear Nuevo Usuario',
        to: '/user/create'
      },
      {
        name: 'Consultar Usuarios',
        to: '/user/consult'
      },
    ]
  },
  /* Funciones del sistema-Title (todos pueden ver esto)*/
  {
    _name: 'CSidebarNavTitle',
    _children: ['Gestión de campañas'],
    roles: [userProfiles.adminUser, userProfiles.coordinator, userProfiles.superviser],
  },
  /* Envios masivos (solo para admin[7], coord[5] y superv[6] ) */
  {
    _name: 'CSidebarNavDropdown',
    name: 'Envíos Masivos',
    to: '/',
    fontIcon: 'fas fa-paper-plane',
    roles: [userProfiles.adminUser, userProfiles.coordinator, userProfiles.superviser],
    items: [{
        name: 'Crear',
        to: '/masiverequests/createmasiverequest'
      },
      {
        name: 'En Proceso',
        to: '/masiverequests/consultmasiverequest'
      },
      {
        name: 'Asignados',
        to: '/masiverequests/requestsAssigned'
      },
    ]
  },
  {
    _name: 'CSidebarNavTitle',
    _children: ['Mis Solicitudes por Procesar'],
  },
  /* Solicitudes individuales (todos pueden ver este menu) */
  {
    _name: 'CSidebarNavItem',
    name: 'Solicitudes Individuales',
    to: '/singlerequests/singleRequest',
    fontIcon: 'fas fa-inbox'
  },
  /* Solicitudes masivas asignadas (todos pueden ver este menu) */
  {
    _name: 'CSidebarNavItem',
    name: 'Solicitudes Masivas',
    to: '/massiverequestforuser/massiveRequestForUser',
    fontIcon: 'fas fa-mail-bulk',
  },
  /* Estadisticas-Title (solo para admin[7], coord[5] y superv[6] ) */
  {
    _name: 'CSidebarNavTitle',
    _children: ['Estadísticas'],
    roles: [userProfiles.adminUser, userProfiles.coordinator, userProfiles.superviser],
  },
  /* Reportes (solo para admin[7], coord[5] y superv[6] ) */
  {
    _name: 'CSidebarNavDropdown',
    name: 'Reportes',
    to: '/',
    fontIcon: 'fas fa-chart-line',
    roles: [userProfiles.adminUser, userProfiles.coordinator, userProfiles.superviser],
    items: [{
        name: 'Solicitudes Procesadas',
        to: '/reports/requestsProcessed',
      },
      {
        name: 'Envíos Individuales',
        to: '/reports/singleRequestsSended',
      },
      {
        name: 'Envíos Masivos',
        to: '/reports/MassiveRequestsSended',
      },
      {
        name: 'Por Empresas',
        to: '/reports/requestsByBussiness',
      },
    ]
  },
]